import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Product'],
  endpoints: (builder) => ({

    getProducts: builder.query({
      query: ({ page = 1, per_page = 20, search = "", category_id = null, in_stock_only = false } = {}) => ({
        url: '/products',
        method: 'GET',
        params: {
          page,
          per_page,
          ...(search ? { search } : {}),
          ...(category_id ? { category_id } : {}),
          ...(in_stock_only ? { in_stock_only: 'true' } : {}),
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Product', id })),
              { type: 'Product', id: 'LIST' },
            ]
          : [{ type: 'Product', id: 'LIST' }],
    }),

    getProductById: builder.query({
      query: (id) => `/products/${id}`,
      providesTags: (result, error, id) => [{ type: 'Product', id }],
    }),

    scanProduct: builder.query({
      query: (code) => `/products/scan/${code}`,
      providesTags: (result, error, code) => [{ type: 'Product', id: `scan-${code}` }],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductByIdQuery,
  useLazyGetProductsQuery,
  useLazyGetProductByIdQuery,
  useLazyScanProductQuery,
} = productApi;
